import { useEffect, useState } from 'react';
import accountStyles from './account-option.style';
import { BankCardAddPayload, BankCardModel, UsdtWalletAddPayload } from 'models/bankModel';
import userApi from 'apis/userApi';

import toast from 'react-hot-toast';
import moment from 'moment';
import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import bankItemBg from 'assets/images/bg/bank-card.jpg';
import { BiPlus } from 'react-icons/bi';
import classNames from 'classnames';
import LoadingIcon from 'components/loading/LoadingIcon';
import Modal from 'components/modal/Modal';
import AddBankPerson from 'components/add-bank/AddBank';
import { IoMdClose } from 'react-icons/io';
import { PiQuestionLight } from 'react-icons/pi';
import { isAddress } from 'ethers';

const bankListBackup = [
    'Ngân Hàng Á Châu (ACB)',
    'Agribank',
    'BIDV',
    'Đông Á',
    'EximBank',
    'Sacombank',
    'Techcombank',
    'Vietinbank',
    'Vietcombank',
    'VIB',
    'VPBank',
    'MaritimeBank',
    'SHB',
    'MBBank',
    'otherBank',
];

const getUsdtWalletAddress = (item: BankCardModel) => {
    if (item.address) return item.address;
    if (item.wallet && isAddress(item.wallet)) return item.wallet;
    if (item.network && isAddress(item.network)) return item.network;
    return item.bankcard || item.wallet || item.network || '';
};

const getUsdtNetwork = (item: BankCardModel) => {
    if (item.network && !isAddress(item.network)) return item.network;
    if (item.wallet && !isAddress(item.wallet)) return item.wallet;
    return item.bankname || 'USDT';
};

function BankAccount() {
    const [isCanAdd, setIsCanAdd] = useState(true);
    const [isCanLock, setIsCanLock] = useState(false);
    const [bankPersonList, setBankPersonList] = useState<BankCardModel[]>([]);
    const [usdtWalletList, setUsdtWalletList] = useState<BankCardModel[]>([]);
    const [loading, setLoading] = useState(false);
    const [showConfirmLock, setShowConfirmLock] = useState(false);
    const [showAddBank, setShowAddBank] = useState(false);
    const [bankList, setBankList] = useState<string[]>([]);
    useEffect(() => {
        const getBankPerson = async () => {
            try {
                const { data } = await userApi.getBankPersonList({});
                if (!data.msg) {
                    handleDataBank(data);
                } else {
                    toast.error(data.msg);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getBankPerson();
    }, []);

    useEffect(() => {
        const getBankList = async () => {
            try {
                const { data } = await userApi.getBankList({});
                if (!data.msg) {
                    if (data.data.length > 0) {
                        setBankList(data.data);
                    } else {
                        setBankList(bankListBackup);
                    }
                } else {
                    toast.error(data.msg);
                    setBankList(bankListBackup);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getBankList();
    }, []);

    const handleDataBank = (data: any) => {
        const isUsdtWallet = (item: any) => Number(item.type) === 1;
        const activeItems = (data.bankcardlist || []).filter((bank: any) => bank.status === 0 || bank.status === 2);
        let bankData = activeItems.filter((item: any) => !isUsdtWallet(item)).map((item: any) => ({ ...item, bankcard: item.bankcard ? `****${item.bankcard.substr(-4)}` : '' }));
        const usdtData = activeItems.filter(isUsdtWallet).map((item: any) => ({ ...item, bankcard: getUsdtWalletAddress(item) }));
        setBankPersonList(bankData);
        setUsdtWalletList(usdtData);

        setIsCanAdd(data.bankcheck < 2 && data.banknumber < 5);
        setIsCanLock(data.bankcheck < 2);
    };

    const submitUsdtWalletAdd = async (payload: UsdtWalletAddPayload) => {
        setLoading(true);
        try {
            const { data } = await userApi.addUsdtWallet(payload);
            if (!data.msg) {
                toast.success('Thêm ví USDT thành công');
                setShowAddBank(false);
                handleDataBank(data);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const submitConfirmLockBank = async () => {
        setLoading(true);
        try {
            const { data } = await userApi.lockBankCardPerson({});
            if (!data.msg) {
                setShowConfirmLock(false);
                setIsCanLock(false);
                setIsCanAdd(false);
                toast.success('Khoá tài khoản thành công');
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const submitBankCardAdd = async (payload: BankCardAddPayload) => {
        setLoading(true);
        try {
            const { data } = await userApi.addBankcardCheckAdd(payload);
            if (!data.msg) {
                toast.success('Thêm ngân hàng thành công');
                setShowAddBank(false);
                handleDataBank(data);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={classNames(accountStyles.wrap, styles.viewAll)}>
                <div className={styles.viewItemInfo}>
                    <div className={styles.itemInfo}>
                        <img alt="" src={require('assets/images/icons/icon-new-check.png')} />
                        <p>
                            Bạn có thể thêm tối đa <span>5</span> tài khoản ngân hàng. Hiện tại bạn đang có <span>0</span> tài khoản.
                        </p>
                    </div>
                    <div className={styles.itemInfo}>
                        <img alt="" src={require('assets/images/icons/icon-new-check.png')} />
                        <p>
                            Từ tài khoản ngân hàng thứ <span>2</span> trở đi phải trùng tên chủ tài khoản với tài khoản đầu tiên
                        </p>
                    </div>
                    <div className={styles.itemInfo}>
                        <img alt="" src={require('assets/images/icons/icon-new-check.png')} />
                        <p>Nếu bạn khoá danh sách tài khoản, bạn sẽ không thể thêm mới hoặc xoá tài khoản ngân hàng</p>
                    </div>
                    <div className={styles.itemInfo}>
                        <img alt="" src={require('assets/images/icons/icon-new-check.png')} />
                        <p>VuiBet không hỗ trợ rút tiền về số thẻ ATM và Viettel Pay</p>
                    </div>
                </div>

                <div className={styles.containerTable}>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <span>STT</span>
                                </td>
                                <td>
                                    <span>Tên ngân hàng</span>
                                </td>
                                <td>
                                    <span>Số tài khoản</span>
                                </td>
                                <td>
                                    <span>Ngày thêm</span>
                                </td>
                            </tr>

                            {[...bankPersonList, ...usdtWalletList].map((item, index) => {
                                const isUsdt = Number(item.type) === 1 || Boolean(item.wallet || item.network || item.address);
                                return (
                                    <tr key={index}>
                                        <td className="background_f4f4f4">{index + 1}</td>
                                        <td className="background_f4f4f4">{isUsdt ? getUsdtNetwork(item) : item.bankname}</td>
                                        <td className="background_f4f4f4">{isUsdt ? getUsdtWalletAddress(item) : item.bankcard}</td>
                                        <td className="background_f4f4f4">{moment(item.savetime).format('DD/MM/yyyy HH:mm:ss')}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>

                <div className={styles.viewButton}>
                    {isCanAdd && (
                        <div className={styles.buttonAdd} onClick={() => setShowAddBank(true)}>
                            <BiPlus size={20} />
                            <p>Đăng ký tài khoản ngân hàng</p>
                        </div>
                    )}
                    {isCanLock && (
                        <button type="button" className={styles.buttonAdd} onClick={() => setShowConfirmLock(true)}>
                            Khoá tài khoản ngân hàng
                        </button>
                    )}
                </div>
            </div>
            {/* confirm lock bank */}
            <Modal isShow={showConfirmLock} onClose={() => setShowConfirmLock(false)} width="400px">
                <div className={styles.popupLock}>
                    <div className={styles.heading}>
                        <h6> {'Thông Báo'}</h6>
                        <button type="button" onClick={() => setShowConfirmLock(false)}>
                            <IoMdClose size={20} color="black" />
                        </button>
                    </div>

                    <div className={styles.contentConfirm}>
                        <PiQuestionLight size={80} color={colors.yellow} />
                        <p className="desc">Sau khi khoá tài khoản ngân hàng, bạn sẽ không thể thêm mới hoặc xoá tài khoản ngân hàng.</p>
                    </div>

                    <div className="action-group-modal">
                        <button type="button" className="btnSubmitLock" onClick={submitConfirmLockBank}>
                            Xác nhận
                        </button>

                        <button type="button" className="btnCancelLock" onClick={() => setShowConfirmLock(false)}>
                            Huỷ
                        </button>
                    </div>
                </div>
            </Modal>

            {/* add bank */}
            <Modal isShow={showAddBank} onClose={() => setShowAddBank(false)} width="1000px" maxWidth="calc(100vw - 32px)" backdropColor="rgba(0, 0, 0, 0.3)">
                <AddBankPerson bankList={bankList} onClose={() => setShowAddBank(false)} onSubmit={submitBankCardAdd} onSubmitUsdt={submitUsdtWalletAdd} />
            </Modal>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    heading: css`
        height: 36px;
        display: flex;
        align-items: center;
        background-color: #f7f7f7;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        h6 {
            font-size: 16px;
            font-weight: 400;
        }
        button {
            display: flex;
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        }
    `,
    contentConfirm: css`
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        gap: 20px;
        .desc {
            font-size: 16px;
        }
    `,
    popupLock: css`
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        .action-group-modal {
            background-color: #f7f7f7;
            padding-top: 5px;
            padding-bottom: 5px;
            padding-right: 5px;
            justify-content: flex-end;
            gap: 1px;
            .btnSubmitLock {
                border: 1px solid #c9820a !important;
                background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
                text-align: center;
                padding: 0 15px;
                height: 32px;
                line-height: 32px;
                margin: 0 0 0 10px;
                cursor: pointer;
                text-decoration: none;
                box-shadow:
                    inset 0 1px 1px rgba(255, 255, 255, 0.5),
                    1px 2px 5px rgba(154, 125, 108, 0.6);
                border-radius: 4px;
            }
            .btnCancelLock {
                height: 32px;
                line-height: 32px;
                margin: 0 0 0 10px;
                padding: 0 15px;
                border: 1px solid #dedede;
                background-color: #fff;
                color: #333;
                border-radius: 2px;
                font-weight: 400;
                cursor: pointer;
                text-decoration: none;
            }
        }
    `,
    viewAll: css``,
    viewButton: css`
        display: flex;
        gap: 20px;
        justify-content: center;
        margin-top: 50px;
    `,
    typeTabs: css`
        display: flex;
        gap: 8px;
        margin-top: 20px;
        button {
            border: 1px solid ${colors.primary};
            border-radius: 3px;
            background: #fff;
            color: ${colors.primary};
            padding: 8px 14px;
            cursor: pointer;
            &.active {
                background: ${colors.primary};
                color: #fff;
            }
        }
    `,
    buttonAdd: css`
        border: 1px solid #c9820a !important;
        border-radius: 3px !important;
        color: #fff !important;
        background: linear-gradient(to bottom, #ffffff 0%, #ffc857 2%, #ffad33 100%);
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        display: flex;
        height: 40px;
        align-items: center;
        cursor: pointer;
    `,
    containerTable: css`
        background-color: #f2f2f2;
        border-radius: 3px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        margin-top: 20px;
        table {
            border-collapse: separate;
            width: 100%;
        }
        td {
            text-align: center;
            background-color: ${colors.primary};
            color: #fff;
            padding: 10px 0;
            text-transform: capitalize;
            font-size: 13px;
            border-radius: 5px;
        }
        tbody {
            display: table-row-group;
            vertical-align: middle;
            unicode-bidi: isolate;
            border-color: inherit;
            box-sizing: border-box;
        }
        .background_f4f4f4 {
            padding: 8px;
            text-align: center;
            font-size: 13px;
            background-color: #e2dfdc;
            border-right: 1px solid #fff;
            border-top: 1px solid #fff;
            border-bottom: 1px solid #d5d2cf;
            color: black;
            font-weight: 300;
        }
    `,
    bankList: css`
        display: flex;
        flex-wrap: wrap;
        margin: 0 -6px;
        min-height: 121px;
    `,
    viewItemInfo: css`
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 30px;
    `,
    itemInfo: css`
        display: flex;
        gap: 20px;
        font-weight: 300;
        p {
            font-size: 17px;
            color: black;
        }
        span {
            color: #f49e1d;
        }
    `,
    bankItem: css`
        flex: 0 0 calc(100% / 3);
        padding: 6px;
    `,
    bankInner: css`
        padding: 12px;
        border-radius: 8px;
        border: 1px solid ${colors.primary};
        background: url(${bankItemBg}) no-repeat;
        background-size: cover;
        display: flex;
        gap: 8px;
    `,
    bankOrder: css`
        background: ${colors['gradient-secondary']};
        font-weight: 500;
        width: 28px;
        height: 28px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
    bankContent: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
        &.pending {
            p {
                &:last-child {
                    color: ${colors.red};
                }
            }
        }
    `,
    bankItemRow: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        p {
            font-size: 14px;
            &:last-child {
                color: ${colors.yellow};
            }
        }
    `,
    addBank: css`
        min-height: 109px;
        border: 2px dashed ${colors.primary};
        border-radius: 8px;
        padding: 12px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        background: rgba(0, 0, 0, 0.5);
        &:hover {
            background: rgba(0, 0, 0, 0.3);
        }
    `,
    ruleAddBank: css`
        padding-left: 20px;
        font-size: 14px;
        margin-top: 20px;
        li {
            margin-bottom: 4px;
        }
        span {
            color: ${colors.red};
            font-weight: 600;
        }
    `,
    note: css`
        font-style: italic;
        font-size: 14px;
        margin-top: 12px;
        span {
            color: ${colors.red};
        }
    `,
    btnLockAccount: css`
        border: 1px solid ${colors.primary};
        color: ${colors.white};
        background: ${colors.bgTitle};
        margin-top: 30px;
        width: 340px;
        &:hover {
            background: ${colors.blackText};
        }
    `,
};

export default BankAccount;
